import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TableConfig } from './class/TableConfig';
import { CommonModule, DatePipe, JsonPipe } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { TableColumn } from './class/TableColumn';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { PageInformations } from './class/PageInformations';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-generic-table',
  standalone: true,
  imports: [
    MatTableModule,
    MatPaginator,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    CommonModule,
  ],
  templateUrl: './generic-table.component.html',
  styleUrl: './generic-table.component.css',
})
export class GenericTableComponent {

  @Input({ required: true }) config: TableConfig = new TableConfig();
  @Input({ required: true }) rows: any[] = [];
  @Input({ required: true }) pageInformations: PageInformations =
    new PageInformations();
  @Input({ required: false }) deletebutton: boolean = false;
  @Input({ required: false }) updatebutton: boolean = false;
  @Input({ required: false }) detailsbutton: boolean = false;
  @Input({ required: false }) affranchibutton: boolean = false;
  @Input({ required: false }) isClickable: boolean = false;
  @Input({ required: false }) emitClickRow: string = '';

  @Output() pageEmit = new EventEmitter<PageEvent>();
  @Output() updateEmit = new EventEmitter<any>();
  @Output() deleteEmit = new EventEmitter<any>();
  @Output() detailsEmit = new EventEmitter<any>();
  @Output() affranchiEmit = new EventEmitter<any>();

  getColumnNames(): string[] {
    return this.config.columns.map((column) => column.id);
  }

  getPropertyValue(column: TableColumn, row: any): any {
    if (column.type == 'date') {
      return new DatePipe('en-US').transform(
        row[column.property],
        "dd/MM/yyyy 'à' HH:mm"
      );
    } else if (column.type == 'hour') {
      return new DatePipe('en-US').transform(row[column.property], 'HH:mm');
    } else if (column.searchOn != undefined) {
      return this.getValueBySearchOn(row, column.searchOn);
    } else {
      return row[column.property];
    }
  }

  getValueBySearchOn(row: any, path: string) {
    return path.split('.').reduce((acc, key) => {
      if (acc && typeof acc === 'object') {
        return acc[key];
      }
      return undefined;
    }, row);
  }

  onPageEvent(event: PageEvent) {
    this.pageEmit.emit(event);
  }

  updateElement(row: any) {
    this.updateEmit.emit(row);
  }

  deleteElement(row: any) {
    this.deleteEmit.emit(row);
  }

  detailsElement(row: any) {
    this.detailsEmit.emit(row);
  }

  affranchiElement(row: any) {
    this.affranchiEmit.emit(row);
  }

  clickRow(row: any) {
    if (this.emitClickRow != '') {
      switch (this.emitClickRow) {
        case 'update':
          this.updateEmit.emit(row);
          break;
        case "details":
          this.detailsEmit.emit(row);
          break;
      }
    }
  }
}
